import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Image from 'components/Image';
import { getLiveProgress } from 'helpers/Live';
import { EPG_LIVE_IMAGE, getDynamicImage, FOX_FALLBACK_IMAGE } from 'helpers/ImageHelper';
import { SITE_PLATFORM_WEB } from 'helpers/BreakpointHelper';
import Style from './LiveImage.module.scss';

const isOver24HoursAway = endDate => {
  const hours24ms = 24 * 1000 * 60 * 60;
  const currentTime24HoursFromNow = Date.now() + hours24ms;
  return currentTime24HoursFromNow < new Date(endDate);
};

const LiveImage = ({
  breakpoint = SITE_PLATFORM_WEB,
  image,
  startDate,
  endDate,
  shouldRender,
  showProgress = true,
}) => {
  const LIVE_PROGRESS_DELAY_MS = 30000;
  const [liveProgress, setLiveProgress] = useState(0);
  const [imageUrl, setImageUrl] = useState(FOX_FALLBACK_IMAGE);

  useEffect(() => {
    if (isOver24HoursAway(endDate)) {
      setLiveProgress(33);
    } else {
      setLiveProgress(getLiveProgress({ startDate, endDate }));
    }
    const timer = setInterval(() => {
      if (!isOver24HoursAway(endDate)) {
        setLiveProgress(getLiveProgress({ startDate, endDate }));
      }
    }, LIVE_PROGRESS_DELAY_MS);
    return () => clearInterval(timer);
  }, [startDate, endDate]);

  useEffect(() => {
    setImageUrl(getDynamicImage({ breakpoint, context: EPG_LIVE_IMAGE, url: image }));
  }, [image, breakpoint]);
  if (!shouldRender) return null;
  return (
    <div className={Style.imageContainer}>
      <Image source={imageUrl || FOX_FALLBACK_IMAGE} className={Style.image} />
      {showProgress && (
        <div className={Style.progressBar}>
          <div className={Style.progress} style={{ width: `${liveProgress}%` }} />
        </div>
      )}
    </div>
  );
};

LiveImage.propTypes = {
  breakpoint: PropTypes.string,
  image: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  shouldRender: PropTypes.bool,
  showProgress: PropTypes.bool,
};

export default React.memo(LiveImage);
